/**
 * @GENERATED from Figma node 3608:51017
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const SpotifyDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#1ED760"
      fillRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m3.725-5.8c.285.163.65.087.82-.184a.55.55 0 0 0-.205-.78c-2.505-1.464-5.626-1.8-9.26-1.009a.56.56 0 0 0-.444.672c.069.304.388.488.707.423 3.325-.715 6.139-.423 8.382.879m.957-2.417c.353.195.809.097 1.025-.24a.686.686 0 0 0-.227-.964c-2.95-1.724-7.256-2.201-10.718-1.204a.697.697 0 0 0-.501.879c.113.368.523.574.922.466 3.03-.879 6.937-.445 9.5 1.063M6.728 9.91c2.938-.845 8.007-.683 11.082 1.052a.88.88 0 0 0 1.207-.303.824.824 0 0 0-.307-1.16C15.179 7.503 9.575 7.308 6.204 8.284c-.467.14-.74.618-.593 1.062.148.456.65.705 1.117.564"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = React.forwardRef(SpotifyDark);
export { ForwardRef as SpotifyDark };
